const updateState = (oldState, newState) =>{
  return {
    ...oldState,
    ...newState
  }
}

const IngredientPrices = {
    salad: 0.5,
    cheese: 0.5,
    meat: 1,
    bacon: 0.7
}


export const addIngredient = (state, action) =>{
  return {
          ...state,
          ingredients: {
              ...state.ingredients,
              [action.ingredient]: state.ingredients[action.ingredient] + 1,

          },
          totalPrice: state.totalPrice + IngredientPrices[action.ingredient],
          building: true
        }

}

export const removeIngredient = (state, action) =>{
  return {
          ...state,
          ingredients: {
              ...state.ingredients,
              [action.ingredient]: (state.ingredients[action.ingredient] > 0) ?
                  state.ingredients[action.ingredient] - 1 : 0
          },
          totalPrice: (state.totalPrice > 4) ? state.totalPrice - IngredientPrices[action.ingredient] : 4,
          building: true
        }
}

export default updateState;



// WEBPACK FOOTER //
// ./src/utility.js